import { render, staticRenderFns } from "./AccidentLogContext.vue?vue&type=template&id=2c8cdb7b&scoped=true&"
import script from "./AccidentLogContext.vue?vue&type=script&lang=js&"
export * from "./AccidentLogContext.vue?vue&type=script&lang=js&"
import style0 from "./AccidentLogContext.vue?vue&type=style&index=0&id=2c8cdb7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8cdb7b",
  null
  
)

export default component.exports